import { wishlistSlice } from '@client/myAccount/wishlists/redux/wishlist/redux';
import { wishlistsSlice } from '@client/myAccount/wishlists/redux/wishlists/redux';
import { combineSlices } from '@reduxjs/toolkit';

export const wishlistsReducer = combineSlices(
  wishlistsSlice,
  wishlistSlice,
);
